import(/* webpackMode: "eager" */ "/vercel/path0/app/mediakit/page.tsx");
